// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3599":"023c6c682f72d1f1","6301":"5c7120f1157d3191"}[chunkId] + ".css";
};